export default
{
  /* SNS LOGIN API KEY */
  LOGIN_API_KEY: [
    // 로컬
    {
      host: 'm.local.host',
      kakao_key: 'b84f9a7e25a2bd8785c17de6d7adb62e',
      google_key: '653779380495-h26005c87pj5s927qaildd9idbk680jd.apps.googleusercontent.com',
      facebook_key: '2200679570049900',
      naver_key: 'MYiG2KtPfq8wbosIFDCQ'
    },
    // 개발
    {
      host: 'm.multi-dev.com',
      kakao_key: 'b84f9a7e25a2bd8785c17de6d7adb62e',
      google_key: '129407983752-sqokckpifvcc0cpfd8vg5u96ctc0t0oh.apps.googleusercontent.com',
      facebook_key: '2336583159899761',
      naver_key: 'utKX_RbHgRccXaiZ7NYZ'
    },
    // 품질
    {
      host: 'm.multi-qa.com',
      kakao_key: 'b84f9a7e25a2bd8785c17de6d7adb62e',
      google_key: '129407983752-sqokckpifvcc0cpfd8vg5u96ctc0t0oh.apps.googleusercontent.com',
      facebook_key: '2336583159899761',
      naver_key: 'FOJzmYcHpMYvEkVsiRkP'
    },
    // 품질
    {
      host: 'mstg.multicampus.com',
      kakao_key: 'b84f9a7e25a2bd8785c17de6d7adb62e',
      google_key: '129407983752-sqokckpifvcc0cpfd8vg5u96ctc0t0oh.apps.googleusercontent.com',
      facebook_key: '2336583159899761',
      naver_key: 'FOJzmYcHpMYvEkVsiRkP'
    },
    // 운영
    {
      host: 'm.multicampus.com',
      kakao_key: 'b84f9a7e25a2bd8785c17de6d7adb62e',
      google_key: '129407983752-sqokckpifvcc0cpfd8vg5u96ctc0t0oh.apps.googleusercontent.com',
      facebook_key: '2336583159899761',
      naver_key: 'Lf2UqlKqr6wZh9SHoewi'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/code/apiKeys.js